import { Observable, fromEvent, map } from 'rxjs';

export function blobToBase64(blob: Blob): Promise<string | ArrayBuffer> {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	return new Promise((resolve, _) => {
		const reader = new FileReader();
		reader.readAsDataURL(blob);
		reader.onloadend = () => resolve(reader.result);
	});
}

export function toBase64(blob: Blob): Observable<string> {
	const reader = new FileReader();
	reader.readAsDataURL(blob);
	return fromEvent(reader, 'load').pipe(map(() => reader.result as string));
}
